import React from 'react'
import { isActionAllowed, makeText } from '../../../util'

import './NeutralButtons.css'

const NeutralButtons = ({
  child,
  vendors,
  value,
  toggle,
  settings,
  dev,
  language,
  toggleStack,
  style,
}) => {
  let { active } = value
  active = value.type && value.type.includes('STACK')
    ? value.categories.every(({ active }) => active)
    : active


  if (value.type && value.type.includes('STACK')) {
    if (value.categories.some(cat => cat.active === null)) {
      active = null
    } else if (value.categories.every(cat => cat.active === false)) {
      active = false
    } else if (value.categories.every(cat => cat.active)) {
      active = true
    } else {
      active = null
    }
  }

  const {
    neutralButtonBackgroundColor,
    neutralButtonFontColor,
    onButtonBackgroundColor,
    onButtonFontColor,
    offButtonBackgroundColor,
    offButtonFontColor,
  } = settings

  const toggleOn = (e) => {
    e.stopPropagation();

    if (toggleStack) {
      toggleStack(e, value.categories, true)
      return
    }

    if (child === 'purposes' || child === 'features') {
      toggle(value._id, child, true, vendors)
    } else if (child === 'vendors') {
      // 'active' refers to 'consent'
      toggle(value.vendorId, true)
    } else if (child === 'stacks') {
      toggle(value._id, true)
    }
  }

  const toggleOff = (e) => {
    e.stopPropagation();

    if (toggleStack) {
      toggleStack(e, value.categories, false)
      return
    }

    if (child === 'purposes' || child === 'features') {
      toggle(value._id, child, false, vendors)
    } else if (child === 'vendors') {
      toggle(value.vendorId, false)
    } else if (child === 'stacks') {
      toggle(value._id, false)
    }
  }

  const acceptButtonStyles = {
    background: active === true ? onButtonBackgroundColor : neutralButtonBackgroundColor,
    color: active === true ? onButtonFontColor : neutralButtonFontColor,
  }

  const rejectButtonStyles = {
    background: active === false ? offButtonBackgroundColor : neutralButtonBackgroundColor,
    color: active === false ? offButtonFontColor : neutralButtonFontColor,
  }

  return (
    <div className="pur-buttons-container" style={style}>
      <button
        style={acceptButtonStyles}
        aria-pressed={active}
        onClick={toggleOn}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleOn(e)}
      >
        {makeText(dev, settings, 'onButtonText', language)}
      </button>
      <button
        style={rejectButtonStyles}
        aria-pressed={active === false}
        onClick={toggleOff}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleOff(e)}
      >
        {makeText(dev, settings, 'offButtonText', language)}
      </button>
    </div>
  )
}

export default NeutralButtons